import { FETCH_HOTEL_IMAGES, FETCH_HOTEL_IMAGES_SUCCESS } from './constants';

const fetchHotelImages = (payload) => ({
  type: FETCH_HOTEL_IMAGES,
  payload,
});

const hotelImagesFetched = (payload) => ({
  type: FETCH_HOTEL_IMAGES_SUCCESS,
  payload,
});

export { fetchHotelImages, hotelImagesFetched };
